export const BookmarkIcon =[
    {
      "Icon":"inbox",
      "Name":"Email"  
    },
    {
        "Icon":"message-square",
        "Name":"Chat"  
    },
    {
        "Icon":"command",
        "Name":"Feather Icon"  
    },
    {
        "Icon":"airplay",
        "Name":"Widgets"  
    }
]

export const Notification =[
    {
        "color":"bg-light-primary",
        "Icon":"activity",
        "Detail":"Delivery processing",
        "Time":"10 minutes ago"
    },
    {   
        "color":"bg-light-secondary",
        "Icon":"check-circle",
        "Detail":"Order Complete",
        "Time":"1 hour ago"
    },
    {
        "color":"bg-light-success",
        "Icon":"file-text",
        "Detail":"Tickets Generated",
        "Time":"3 hour ago"
    },
    {
        "color":"bg-light-danger",
        "Icon":"user-check",
        "Detail":"Delivery Complete",
        "Time":"6 hour ago"
    }
]

export const Message =[
    {
        "src":"4.jpg",
        "Name":"Ain Chavez",
        "Detail":"Lorem Ipsum is simply dummy...",
        "Time":"32 mins ago"
    },
    {
        "src":"1.jpg",
        "Name":"Erica Hughes",
        "Detail":"Lorem Ipsum is simply dummy...",
        "Time":"58 mins ago"
    },
    {
        "src":"2.jpg",
        "Name":"Kori Thomas",
        "Detail":"Lorem Ipsum is simply dummy...",
        "Time":"1 hr ago"
    }
]

export const languageData =[
    {
        "langname":"English",
        "sortname":"(US)",
        "icon":"flag-icon-us",
        "value":"en"
    },
    {
        "langname":"Deutsch",
        "icon":"flag-icon-de",
        "value":"de"
    },
    {
        "langname":"Español",
        "icon":"flag-icon-es",
        "value":"es"
    },
    {
        "langname":"Français",
        "icon":"flag-icon-fr",
        "value":"fr"
    },
    {
        "langname":"Português",
        "sortname":"(BR)",
        "icon":"flag-icon-pt",
        "value":"pt"
    },
    {
        "langname":"简体中文",
        "icon":"flag-icon-cn",
        "value":"cn"
    },
    {
        "langname":"لعربية",
        "sortname":"(ae)",
        "icon":"flag-icon-ae",
        "value":"ae"
    }
    
]